import {AdvertConversation} from '#/Advert';
import {Conversation, Conversations} from '#/Conversations';

export enum AdminMessageType {
    POPUP = 1,
    EULA = 2,
    MESSAGE = 3,
}

export interface ConversationsState {
    advertsConversation: AdvertConversation[];
    conversation: Conversation,
    conversations: Conversations;
    messageUnreadNumber: number;
}

export const state: ConversationsState = {
    advertsConversation: [],
    conversation: {
        advert: {
            id: null,
            title: '',
        },
        messages: [],
    },
    conversations: {},
    messageUnreadNumber: 0,
};
